<template>
  <div class="container">
    <SelectStore @selectStore="handleSelectStore"/>
    <div class="right-container">
      <div class="list-container" :style="{height: height}">
        <div class="header">骑手取货管理</div>
        <div class="toolbar">
          <el-select v-model="shipment" filterable placeholder="请选择线上店铺" style="width: 260px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="未取货" value="1"></el-option>
            <el-option label="骑手自取货" value="2"></el-option>
            <el-option label="客服帮取货" value="3"></el-option>
          </el-select>
          <el-input placeholder="查询关键字" v-model="keyword" :clearable="true" :style="{ width:'250px',marginTop: '15px',float: 'right'}">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <el-table :data="ordFreightList"
                  highlight-current-row
                  ref="table"
                  v-loading="loading"
                  :max-height="tableMaxHeight"
                  @sort-change="handleSortChange">
          <el-table-column label="序号" type="index" align="center" width="60px" :index="getIndex"></el-table-column>
          <el-table-column label="取货号" align="center" width="90px" prop="cfetch"></el-table-column>
          <el-table-column label="门店名称" align="left" width="200px" prop="sstore" sortable="custom"></el-table-column>
          <el-table-column label="流水号" align="center" width="100px" prop="corderSerial"></el-table-column>/
          <el-table-column label="配送平台" align="center" width="120px" prop="splatform"></el-table-column>
          <el-table-column label="配送单号" align="center" width="130px" prop="csys" sortable="custom">
            <template #default="scope">
              <div class="link" @click="view(scope.row)">{{ scope.row.cSys }}</div>
            </template>
          </el-table-column>
          <el-table-column label="距离" align="left" width="100px" prop="ndistance" sortable="custom">
            <template #default="scope">
              <div class="link">{{ scope.row.ndistance }}</div>
            </template>
          </el-table-column>
          <el-table-column label="货品" align="center" width="80px" >
            <template #default="scope">
              <div class="link" @click="viewOrdPicking(scope.row)">明细</div>
            </template>
          </el-table-column>
          <el-table-column label="骑手" align="left" width="90px" prop="srider" sortable="custom">
            <template #default="scope">
              <div class="link">{{ scope.row.srider }}</div>
            </template>
          </el-table-column>
          <el-table-column label="手机" align="center" width="130px" prop="criderPhone" sortable="custom">
            <template #default="scope">
              <div class="link">{{ scope.row.criderPhone }}</div>
            </template>
          </el-table-column>
          <el-table-column label="配送接单时间" align="center" width="140x" prop="treceive" :formatter="dateFormatter" sortable="custom"></el-table-column>
          <el-table-column label="标识" align="center" width="80px" prop="bstatus" sortable="custom">
            <template #default="scope">
              <span>{{ formatterFlag(scope.row.bshipment) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="80px" prop="bStatus" sortable="custom">
            <template #default="scope">
              <span :style="{ color:getFreightStatusColor(scope.row.bstatus)}">{{ getFreightStatus(scope.row.bstatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="view(scope.row)">详情</el-button>
              <el-button type="text" @click="viewOrdPicking(scope.row)" v-if="scope.row.bstatus > 3 && scope.row.bstatus !== 6">快照</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :layout="pageLayout"
          :total="total"
          :current-page="pageNum"
          :page-sizes="pageSelect"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :style="{marginTop: '15px'}">
        </el-pagination>
        <ViewOrdPickingDetail :visible.sync="showViewOrdPickingDetail" :rPicking="currentRPicking" @close="handleCloseViewOrdPickingDetail"/>
        <ViewOrdFreightDetail :visible.sync="showViewOrdFreightDetail" :sid="currentSid" @close="handleCloseViewOrdFreightDetail"/>
      </div>
    </div>
  </div>
</template>

<script>
import {getOrdFreightFetchList} from "@/api/delivery/delivery";
import {freightTypeMap, freightStatusMap, freightStatusColorMap} from "@/utils/deliveryMap";
import {formatTime} from "@/utils/utils";
import SelectStore from "@/views/components/SelectStore";
import ViewOrdPickingDetail from "@/views/components/DeliveryOrder/ViewOrdPickingDetail";
import ViewOrdFreightDetail from "@/views/components/DeliveryOrder/ViewOrdFreightDetail";

export default {
  name: "deliverySelfPickupGoodsOrder",
  components: {SelectStore,ViewOrdFreightDetail,ViewOrdPickingDetail},
  data() {
    return {
      height: document.documentElement.clientHeight - 60 + "px",
      tableMaxHeight: document.documentElement.clientHeight - 260,
      currentSid:'',
      currentRPicking:'',
      showViewOrdPickingDetail: false,
      showViewOrdFreightDetail: false,
      rStores:[],
      keyword:'',
      ordFreightList:[],
      loading:false,
      total: 0, //总条数
      pageNum: 1, //当前页
      pageSize: 10, //每页显示条数
      pageSelect: [10, 20, 30, 50],
      pageLayout:"prev, pager, next,jumper,total,sizes",
      orderByColumn:'',
      isAsc:'',
      shipment: "",
      sortCustom: {
        "sStore": "s_store",
        "cSys": "c_sys",
        "nDistance": "n_distance",
        "sRider": "s_rider",
        "cRiderPhone": "c_rider_phone",
        "tReceive": "t_receive",
        "bStatus": "b_status",
      },
    };
  },
  created() {
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  computed: {
    getFreightType() {
      return function(bType) {
        return freightTypeMap[bType] || '未知';
      };
    },
    getFreightStatus() {
      return function(bType) {
        return freightStatusMap[bType] || '未知';
      };
    },
    getFreightStatusColor() {
      return function(bStatus) {
        return freightStatusColorMap[bStatus] || '#606266';
      };
    },
  },
  methods: {
    formatterFlag(val) {
      if (val === 1) {
        return "待取货";
      } else if (val === 2) {
        return "骑手取货";
      } else {
        return "客服帮取";
      }
    },
    getOrdFreightFetchList() {
      let params = {
        search:this.keyword,
        rStores:this.rStores,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        orderByColumn: this.orderByColumn,
        shipment: this.shipment,
        isAsc: this.isAsc,
      }
      this.loading = true;
      getOrdFreightFetchList(params).then(result => {
        if (result) {
          this.ordFreightList = result.rows;
          this.total = result.total;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSortChange({ prop, order }) {
      if (order) {
        this.orderByColumn = this.sortCustom[prop];
        this.isAsc = order === 'ascending' ? 'asc' : 'desc';
        this.getOrdFreightFetchList();
      }else{
        this.orderByColumn = '';
        this.isAsc = '';
        this.getOrdFreightFetchList();
      }
    },
    // 查询
    search(){
      this.pageNum = 1;
      this.getOrdFreightFetchList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getOrdFreightFetchList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getOrdFreightFetchList();
    },
    handleSelectStore(e) {
      this.rStores = e;
      this.pageNum = 1;
      this.getOrdFreightFetchList();
    },
    view(item){
      this.currentSid = item.sid;
      this.showViewOrdFreightDetail = true;
    },
    viewOrdPicking(item){
      this.currentRPicking = item.rpicking;
      this.showViewOrdPickingDetail = true;
    },
    handleCloseViewOrdPickingDetail() {
      this.showViewOrdPickingDetail = false;
    },
    handleCloseViewOrdFreightDetail() {
      this.showViewOrdFreightDetail = false;
    },
    getIndex(rowIndex) {
      return (this.pageNum - 1) * this.pageSize + rowIndex +1;
    },
    dateFormatter(row, column, cellValue) {
      return cellValue?formatTime(cellValue,"YYYY-MM-DD HH:mm"):'';
    },
    handleKeydown(event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        this.pageNum = 1;
        this.getOrdFreightFetchList();
      }
    },
  },
  watch: {
    rStores(newVal) {
      // this.pageNum = 1;
      // this.getOrdFreightList();
    },
  },
};
</script>

<style lang="scss" scoped>
.container{
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
}
.right-container{
  float:left;
  width:calc(100% - 240px);
  height: 100%;
}
.list-container{
  width: 100%;
  border: 1px solid #ddd;
  padding: 0px 20px;
  .header{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    padding-left: 5px;
    border-bottom: 1px solid #ddd;
  }
  .toolbar{
    width: 100%;
    height: 60px;
  }
}
.link{
  color:#409EFF;
  cursor: pointer;
}
</style>
